/* eslint-disable no-unused-vars */
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Select from "react-select";
import * as yup from "yup";
import {
  fundType,
  reconciliationSource,
} from "../../../../../utils/helpers/objectHelpers";

function CreditAccount({ dictionary, currency }) {
  const formRef = useRef();
  const dispatch = useDispatch();
  const menuPortalTarget = document.getElementById("root");
  const [passwordShown, setPasswordShown] = useState(false);
  const [eyeOpen, setEyeOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const schema = yup
    .object({
      currencyCode: yup
        .object()
        .shape({
          iso3Code: yup.string(),
          label: yup.string(),
          value: yup.string(),
          currencyCode: yup.string(),
        })
        .required(),
      fundType: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      currentBalance: yup.string().notRequired(),
      amount: yup.number().required(),
      message: yup.string().notRequired(),
      password: yup.string().required(),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {};
  return (
    <form
      className="needs-validation"
      ref={formRef}
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="form-row">
        <div className="col-md-6 col-lg-6 mb-3">
          <label>
            {dictionary ? dictionary["WO_FUND_TYP_-387152637"] : "Fund Type"}
          </label>
          <Controller
            name="fundType"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => {
              return (
                <Select
                  {...field}
                  options={fundType}
                  isClearable={false}
                  isSearchable={true}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  menuPortalTarget={menuPortalTarget}
                />
              );
            }}
          />
        </div>
        <div className="col-md-6 col-lg-6 mb-3">
          <label>
            {dictionary ? dictionary["para_currency_code"] : "Currency Code"}
          </label>
          <Controller
            name="currencyCode"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => {
              return (
                <Select
                  {...field}
                  options={currency}
                  isClearable={false}
                  isSearchable={true}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  menuPortalTarget={menuPortalTarget}
                />
              );
            }}
          />
        </div>
        <div className="col-md-6 col-lg-6 mb-3">
          <div className="form-row">
            <div className="col-md-6 col-lg-6">
              <label>
                {dictionary ? dictionary["WO_AMOUN_1657560372"] : "Amount"}
              </label>
              <input
                type={"number"}
                className="form-control border px-3"
                name="amount"
                {...register("amount", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>
            <div className="col-md-6 col-lg-6">
              <label>
                {dictionary
                  ? dictionary["para_current_balance"]
                  : "Current Balance"}
              </label>
              <input
                type={"text"}
                className="form-control border px-3"
                name="currentBalance"
                {...register("currentBalance", {
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                })}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-6 mb-3">
          <label>
            {dictionary
              ? dictionary["WO_RECONCILIATION_SOURC_-298108657"]
              : "Reconciliation Source"}
          </label>
          <Controller
            name="reconciliationSource"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => {
              return (
                <Select
                  {...field}
                  options={reconciliationSource}
                  isClearable={false}
                  isSearchable={true}
                  maxMenuHeight={250}
                  menuPlacement="bottom"
                  menuPortalTarget={menuPortalTarget}
                />
              );
            }}
          />
        </div>
        <div className="col-md-6 col-lg-6 mb-3">
          <label>
            {dictionary ? dictionary["l_transaction_note"] : "Transaction Note"}
            {/* <span style={{ color: "red" }}> *</span> */}
          </label>
          <textarea
            className="form-control border px-3"
            name="message"
            {...register("message", {
              required: {
                value: true,
                message: "This field is required",
              },
            })}
          />
        </div>
        <div className="col-md-6 col-lg-6 mb-3 position-relative">
          <label>
            {dictionary ? dictionary["WO_PASSWOR_-1150637439"] : "Password"}
          </label>
          <input
            type={passwordShown ? "text" : "password"}
            className="form-control border px-3"
            name="password"
            {...register("password", {
              required: {
                value: true,
                message: "This field is required",
              },
            })}
          />
          {!eyeOpen ? (
            <i
              className="fa fa-eye-slash position-absolute"
              style={{ top: "43%", right: "5%", cursor: "pointer" }}
              onClick={() => {
                setEyeOpen(!eyeOpen);
                togglePasswordVisiblity();
              }}
            />
          ) : (
            <i
              className="fa fa-eye position-absolute"
              style={{ top: "43%", right: "5%", cursor: "pointer" }}
              onClick={() => {
                setEyeOpen(!eyeOpen);
                togglePasswordVisiblity();
              }}
            />
          )}
        </div>

        <div className="col-lg-6 col-md-6 mb-3" />
        <div className="col-lg-6 col-md-6 mb-3">
          <button
            className="btn btn-primary margin-label width-100 fw-bold text-uppercase"
            type="submit"
            disabled
          >
            {dictionary
              ? dictionary["b_wallet_fund_account"]
              : "CREDIT ACCOUNT"}
            {loading && (
              <>
                &nbsp;
                <i className="fa fa-spinner fa-spin" />
              </>
            )}
          </button>
        </div>
      </div>
    </form>
  );
}

export default CreditAccount;
